import React, { useEffect, useState } from 'react';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { Button } from 'app/shared/button';
import { useSentryService } from 'hooks/sentry';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { addOneSentryToStore } from 'store/actions/sentry';

export const SentryCreation = ({ initial_data = {} }) => {
  const dispatch = useDispatch();
  const { create, update } = useSentryService();

  const [url, setUrl] = useState('');
  const [is_saving, setIsSaving] = useState(false);

  useEffect(() => {
    if (initial_data.url) setUrl(initial_data.url);
  }, [initial_data.id]);

  const submit = async () => {
    if (!url) return toast.error('URL is required');

    const data = { url };
    let result = null;
    try {
      setIsSaving(true);
      if (initial_data.id) {
        result = await update(initial_data.id, { data });
      } else {
        result = await create({ data });
      }
    } finally {
      setIsSaving(false);
    }

    if (result) {
      dispatch(addOneSentryToStore({ ...initial_data, ...data }));
      toast.success(`Sentry ${initial_data.id ? 'updated' : 'created'} successfully`);
    }
  };

  return (
    <>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="URL">
            <SimpleInput value={url} onInput={setUrl} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={2}>
        <GridColumn />
        <GridColumn>
          <Button
            loading={is_saving}
            disabled={is_saving}
            text={initial_data.id ? 'Update Sentry' : 'Create Sentry'}
            onClick={submit}
          />
        </GridColumn>
      </GridRow>
    </>
  );
};
